import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { termsOfService } from './legalContent';

const Terms = () => {
  return <LegalPageLayout document={termsOfService} />;
};

export default Terms;
